module.exports = __webpack_public_path__ + "img/error.34949a88.gif";